import BoardsSection from './components/BoardsSection'

export function renderSecondaryNavBoardSection(section, ctx) {
  const key = `${section.type}-${ctx.index}`

  if (section.type === 'boardsPreview') {
    return (
      <BoardsSection
        key={key}
        boards={ctx.topBoards}
        pinnedThreadIds={ctx.pinnedThreadIds}
        threads={ctx.threads}
        selectedThreadId={ctx.selectedThreadId}
        onSelectThread={ctx.onThreadSelect}
        onThreadMenuAction={ctx.onThreadMenuAction}
        onRenameThread={ctx.onRenameThread}
      />
    )
  }

  if (section.type === 'boardsLanding') {
    return (
      <BoardsSection
        key={key}
        boards={ctx.allBoards}
        showAll
        onBoardClick={(board) => {
          ctx.onThreadSelect?.({ id: board.id, title: `${board.name} selected` })
        }}
      />
    )
  }

  return null
}
